import { connect } from 'react-redux';

import { setMapsAsSeen } from '../store/bulletin/actions';

import BulletinViewPage from '../components/BulletinView/BulletinViewPage';

const mapStateToProps = state => ({
  userHasBulletinPermission: state.connection.hasBulletinPermission,
  userIsAuthenticated: state.connection.userIsAuthenticated,
  bulletinComment: state.bulletin.bulletinComment,
});

const mapDispatchToProps = dispatch => ({
  setMapsAsSeen: mapStatus => dispatch(setMapsAsSeen(mapStatus)),
});

const BulletinPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BulletinViewPage);

export default BulletinPage;
